<template>
	<div>
		<v-row dense>
			<v-col cols="12" sm="6" md="6" lg="6" xl="6">
				<v-btn @click="$vuetify.theme.dark = !$vuetify.theme.dark" class="mr-2">
					<span>{{ $vuetify.theme.dark ? 'Light Mode' : 'Dark Mode' }}</span>
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
// locals
import i18n from './dictionary';
// models
// components

export default {
	name: `DisplayTab`,
	i18n,
};
</script>
